// Portfolio Mock Data for Joel Thomas - Cybersecurity Professional
// Expanded content for a comprehensive portfolio

export const profileData = {
  name: "Joel Thomas",
  firstName: "Joel",
  lastName: "Thomas",
  initials: "JT",
  title: "System Administrator & Cybersecurity Analyst",
  tagline: "Building secure, scalable, and resilient digital infrastructure",
  email: "joelthomas0324@gmail.com",
  phone: "+1 587-991-7959",
  location: "Edmonton, Alberta, Canada",
  timezone: "MST",
  status: "Available for Work",
  summary: "Highly motivated and technically proficient Cybersecurity Professional with hands-on experience in managing enterprise servers, implementing security protocols, and protecting digital infrastructure. Specialized in vulnerability assessment, incident response, and secure system administration.",
  social: {
    github: "https://github.com/joelthomas",
    linkedin: "https://linkedin.com/in/joelthomas",
    twitter: "https://twitter.com/joelthomas"
  }
};

export const experienceData = [
  {
    id: 1,
    company: "PCL Construction",
    logo: "https://customer-assets.emergentagent.com/job_a731ae36-dcc6-42d3-87c1-a0f4c3b1d343/artifacts/b7ux95y0_PCL-logo-for-web.png",
    role: "System Administrator",
    duration: "2023 - 2024",
    location: "Edmonton, AB",
    type: "Full-time",
    description: "Server management, security implementation, and IT infrastructure optimization for one of Canada's largest construction companies.",
    highlights: [
      "Managed and maintained 8 servers across various platforms, ensuring high performance and reliability, contributing to a 40% increase in system uptime.",
      "Resolved an average of 60 tickets per week, demonstrating exceptional problem-solving skills and dedication to maintaining high service standards.",
      "Administered user accounts and permissions using Active Directory for over 2000 employees, enhancing organizational security and operational efficiency.",
      "Implemented security patches and system updates across Windows, MacOS, and Linux environments.",
      "Conducted security audits and vulnerability assessments to identify and mitigate potential threats.",
      "Deployed endpoint detection and response (EDR) solutions across 500+ workstations."
    ]
  },
  {
    id: 2,
    company: "Maxwell Real Estate",
    logo: null,
    role: "Computer Support Technician",
    duration: "2018 - 2019",
    location: "Edmonton, AB",
    type: "Full-time",
    description: "End-user support and IT infrastructure management for a growing real estate firm.",
    highlights: [
      "Provided excellent end-user support and assistance, ensuring prompt and efficient problem resolution.",
      "Analyzed, diagnosed, and resolved simple and complex computer problems for end users.",
      "Documented and tracked the incident-solving process, recording all successful and unsuccessful decisions.",
      "Collaborated with higher-tier support analysts to ensure efficient operation of the end-user computing environment.",
      "Managed equipment warranty and repair depot processes."
    ]
  },
];

export const educationData = {
  degree: "Bachelor of Science",
  major: "Computing Science - Information Security/Cyber Security",
  minor: "Psychology",
  institution: "Grant MacEwan University",
  logo: "https://customer-assets.emergentagent.com/job_a731ae36-dcc6-42d3-87c1-a0f4c3b1d343/artifacts/zrsqfo9v_MacEwanU-Logo.svg.png",
  location: "Edmonton, AB",
  graduationDate: "August 2021",
  gpa: "3.7/4.0",
  coursework: [
    "Network Security",
    "Cryptography",
    "Digital Forensics",
    "Ethical Hacking",
    "Secure Software Development",
    "Risk Management",
    "Operating Systems Security",
    "Database Security"
  ]
};

export const projectsData = [
  {
    id: 1,
    name: "Tutor Time",
    description: "A comprehensive tutoring application designed to connect students with tutors. Features include dashboard, calendar scheduling, task management, chat functionality, and subject-based organization covering Math, Physics, Chemistry, Biology, English, History, and Science.",
    logo: "https://customer-assets.emergentagent.com/job_a731ae36-dcc6-42d3-87c1-a0f4c3b1d343/artifacts/zpx525sx_tutor%20time.png",
    screenshot: "https://customer-assets.emergentagent.com/job_a731ae36-dcc6-42d3-87c1-a0f4c3b1d343/artifacts/8bjkm00h_unnamed.png",
    technologies: ["React Native", "Node.js", "MongoDB", "Socket.io"],
    features: ["Real-time Chat", "Calendar Sync", "Task Management", "Video Calls"],
    category: "Mobile Application",
    link: "#"
  }
];

// Expanded Cybersecurity Skills
export const skillsData = {
  security: [
    "Vulnerability Assessment",
    "Penetration Testing",
    "Incident Response",
    "Threat Intelligence",
    "Security Auditing",
    "Risk Assessment",
    "Malware Analysis",
    "Network Security",
    "Endpoint Security",
    "Cloud Security",
    "Identity & Access Management",
    "Security Compliance",
    "SIEM Management",
    "Forensic Analysis"
  ],
  tools: [
    "Splunk",
    "Wireshark",
    "Nmap",
    "Metasploit",
    "Burp Suite",
    "Nessus",
    "Kali Linux",
    "OSSEC",
    "Snort",
    "CrowdStrike",
    "Carbon Black",
    "Qualys",
    "Tenable",
    "Rapid7"
  ],
  platforms: [
    "Active Directory",
    "Azure AD",
    "AWS Security",
    "Microsoft 365",
    "ServiceNow",
    "Jira",
    "Windows Server",
    "Linux (RHEL/Ubuntu)",
    "VMware",
    "Docker",
    "Kubernetes",
    "Terraform"
  ],
  frameworks: [
    "NIST Cybersecurity",
    "ISO 27001",
    "CIS Controls",
    "MITRE ATT&CK",
    "OWASP Top 10",
    "PCI DSS",
    "SOC 2",
    "GDPR",
    "HIPAA",
    "Zero Trust"
  ],
  programming: [
    "Python",
    "Bash/Shell",
    "PowerShell",
    "SQL",
    "JavaScript",
    "Go",
    "YAML",
    "JSON"
  ],
  networking: [
    "TCP/IP",
    "DNS/DHCP",
    "VPN",
    "Firewalls",
    "IDS/IPS",
    "Load Balancers",
    "Proxy Servers",
    "Network Segmentation",
    "SSL/TLS",
    "PKI"
  ]
};

export const certificationsData = [
  {
    id: 1,
    name: "Google IT Support Professional",
    issuer: "Google",
    year: "2023",
    credentialId: "GOOGLE-IT-2023"
  },
  {
    id: 2,
    name: "Google Cybersecurity Professional",
    issuer: "Google",
    year: "2023",
    credentialId: "GOOGLE-SEC-2023"
  },
  {
    id: 3,
    name: "CompTIA Security+ (In Progress)",
    issuer: "CompTIA",
    year: "2025",
    credentialId: "Expected Q2 2025"
  }
];

// Stats for hero section
export const statsData = [
  { label: "Years Experience", value: "4+" },
  { label: "Projects Delivered", value: "20+" },
  { label: "Users Secured", value: "2000+" }
];

// Services/Expertise areas
export const servicesData = [
  {
    id: 1,
    title: "Security Operations",
    description: "24/7 security monitoring, incident detection and response, threat hunting, and security event management using SIEM platforms like Splunk and Elastic.",
    icon: "shield"
  },
  {
    id: 2,
    title: "Vulnerability Management",
    description: "Regular vulnerability scanning, assessment, prioritization, and remediation tracking using Nessus, Qualys, and custom scripts.",
    icon: "scan"
  },
  {
    id: 3,
    title: "System Administration",
    description: "Enterprise server management, Active Directory administration, user provisioning, and system hardening across Windows and Linux environments.",
    icon: "server"
  },
  {
    id: 4,
    title: "Network Security",
    description: "Firewall configuration, network segmentation, VPN management, and intrusion detection/prevention system deployment and tuning.",
    icon: "network"
  },
  {
    id: 5,
    title: "Cloud Security",
    description: "Azure and AWS security configuration, identity management, cloud compliance, and secure cloud architecture implementation.",
    icon: "cloud"
  },
  {
    id: 6,
    title: "Penetration Testing",
    description: "Ethical hacking, web application security testing, network penetration testing, and comprehensive security assessments.",
    icon: "target"
  }
];

// Approach/Process
export const approachData = [
  {
    phase: "01",
    title: "Planning & Strategy",
    description: "We'll collaborate to map out your security goals, assess current infrastructure, identify risks, and develop a comprehensive security roadmap tailored to your needs."
  },
  {
    phase: "02",
    title: "Implementation & Hardening",
    description: "Once we agree on the plan, I implement security controls with a defense-in-depth approach. From initial configuration to system hardening, I keep you updated every step."
  },
  {
    phase: "03",
    title: "Monitor, Test & Improve",
    description: "Continuous security monitoring, regular penetration testing, and ongoing optimization ensure your security posture remains strong against evolving threats."
  }
];

// Testimonials
export const testimonialsData = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "IT Director",
    company: "TechStart Inc.",
    quote: "Joel's expertise in cybersecurity transformed our security posture. His proactive approach to threat detection saved us from multiple potential breaches.",
    avatar: null
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "CTO",
    company: "DataFlow Systems",
    quote: "Working with Joel was a game-changer. He not only secured our infrastructure but also trained our team on security best practices.",
    avatar: null
  },
  {
    id: 3,
    name: "Amanda Rodriguez",
    role: "Operations Manager",
    company: "SecureHealth Corp",
    quote: "Joel's attention to detail and deep knowledge of compliance frameworks helped us achieve HIPAA compliance ahead of schedule.",
    avatar: null
  }
];

// Tech stack for the marquee
export const techStackData = [
  "Python", "Splunk", "Wireshark", "Nmap", "Metasploit", "Azure", "AWS",
  "Docker", "Kubernetes", "Linux", "Windows Server", "Active Directory",
  "Terraform", "Ansible", "Git", "SIEM", "EDR", "XDR"
];
